import { render, staticRenderFns } from "./PastConferences.vue?vue&type=template&id=a0cc3088&"
import script from "./PastConferences.vue?vue&type=script&lang=ts&"
export * from "./PastConferences.vue?vue&type=script&lang=ts&"
import style0 from "./PastConferences.vue?vue&type=style&index=0&id=a0cc3088&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports